// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_courseList__nzmew {
  border-top: 1px solid var(--color-gray-strokes);
  border-radius: 0;
  margin: 1px 0;
  padding: 16px 16px 0px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 0;
}

.styles_courseItem__QkFyK {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 1px 0;
}

.styles_courseDiamond__j6Q3K {
  flex-shrink: 0;
}

.styles_courseText__XFMuP {
  font-size: 14px;
  line-height: 1.5;
  color: #1a1a1a;
}

.styles_calendarSection__Tt7PN {
  overflow-x: hidden;
  max-width: 100%;
}
@media (min-width: 768px) {
  .styles_calendarSection__Tt7PN {
    overflow-x: visible;
    max-width: none;
  }
}

.styles_calendarGrid__G83Hd {
  display: none;
}
@media (min-width: 768px) {
  .styles_calendarGrid__G83Hd {
    display: flex;
    gap: 16px;
    justify-content: center;
    align-items: center;
  }
}

.styles_calendarCarousel__71hxB {
  display: block;
}
@media (min-width: 768px) {
  .styles_calendarCarousel__71hxB {
    display: none;
  }
}

.styles_carouselContainer__--4RE {
  overflow-x: hidden;
  width: 100%;
  max-width: 100%;
  position: relative;
  margin: 10px 0;
}

.styles_carouselTrack__7z2nE {
  display: flex;
  transition: transform 0.3s ease-in-out;
  gap: 8px;
  padding: 0 calc(50% - 82px);
}

.styles_carouselSlide__Thm9y {
  flex: 0 0 163px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.styles_calendarCard__F-ZAL {
  width: 160px;
  height: 60px;
  border: 3px solid var(--color-gray-strokes);
  border-radius: 12px;
  background-color: var(--color-white);
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}
.styles_calendarCard__F-ZAL:hover {
  border: 1px solid var(--color-gray-strokes);
  background: var(--color-bg-light-blue);
}
.styles_calendarCard__F-ZAL:focus {
  border-color: black;
}

.styles_calendarCardSelected__4OWW8 {
  border-color: black;
  background-color: var(--color-bg-light-blue);
}
.styles_calendarCardSelected__4OWW8:hover {
  background-color: var(--color-bg-light-blue);
  border-color: black;
}

.styles_calendarIcon__A2iDz {
  width: 32px;
  height: 32px;
  object-fit: contain;
  position: relative;
  transition: all 0.3s ease;
}
@media (min-width: 768px) {
  .styles_calendarIcon__A2iDz {
    width: 40px;
    height: 40px;
  }
}
.styles_calendarCard__F-ZAL:hover .styles_calendarIcon__A2iDz {
  filter: drop-shadow(-16px 0 0 rgba(0, 0, 0, 0.4)) drop-shadow(-32px 0 0 rgba(0, 0, 0, 0.2)) drop-shadow(16px 0 0 rgba(0, 0, 0, 0.4)) drop-shadow(32px 0 0 rgba(0, 0, 0, 0.2));
}

.styles_dotsContainer__\\+fGv7 {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
  margin-bottom: 8px;
}

.styles_dot__84eo8 {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--color-gray-strokes);
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
}
.styles_dot__84eo8:hover {
  background-color: var(--color-accent-blue);
  opacity: 0.7;
}
.styles_dot__84eo8:focus {
  outline: 2px solid var(--color-accent-blue);
  outline-offset: 2px;
}

.styles_dotActive__Ae2Bc {
  background-color: var(--color-accent-blue);
  transform: scale(1.2);
}

.styles_addEventsButton__SCGyT {
  width: 100%;
  margin-top: 0px;
}
@media (min-width: 768px) {
  .styles_addEventsButton__SCGyT {
    margin-top: 0px;
  }
}

.styles_optionalSyncText__O-fg7 {
  width: 100%;
  text-align: center;
  color: var(--color-text-secondary, #666);
  font-size: 16px;
  margin: 0;
  padding: 16px 16px 0 16px;
  border-top: 1px solid var(--color-gray-strokes);
  box-sizing: border-box;
}

.styles_infoMessage__yNRX8 {
  border-radius: 0;
  padding: 0px 16px 0px 16px;
  display: flex;
  justify-content: center;
  gap: 4px;
  color: #4285F4;
  font-size: 16px;
}
.styles_infoMessage__yNRX8 .styles_infoIcon__G3ezc {
  width: 22px;
  height: 22px;
}
.styles_infoMessage__yNRX8 span {
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/screens/select-calendar/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,+CAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAAF;;AAGA;EACE,kBAAA;EACA,eAAA;AAAF;ACxBE;EDsBF;IAKI,mBAAA;IACA,eAAA;EACF;AACF;;AAEA;EACE,aAAA;AACF;AClCE;EDgCF;IAII,aAAA;IACA,SAAA;IACA,uBAAA;IACA,mBAAA;EAEF;AACF;;AACA;EACE,cAAA;AAEF;AC9CE;ED2CF;IAII,aAAA;EAGF;AACF;;AAAA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAGF;;AAAA;EACE,aAAA;EACA,sCAAA;EACA,QAAA;EACA,2BAAA;AAGF;;AAAA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAGF;;AAAA;EACE,YAAA;EACA,YAAA;EACA,2CAAA;EACA,mBAAA;EACA,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAGF;AADE;EACE,2CAAA;EACA,sCAAA;AAGJ;AAAE;EACE,mBAAA;AAEJ;;AAEA;EACE,mBAAA;EACA,4CAAA;AACF;AACE;EACE,4CAAA;EACA,mBAAA;AACJ;;AAGA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AAAF;ACnHE;ED8GF;IAQI,WAAA;IACA,YAAA;EACF;AACF;AACE;EACE,6KACE;AAAN;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,UAAA;AALF;AAOE;EACE,0CAAA;EACA,YAAA;AALJ;AAQE;EACE,2CAAA;EACA,mBAAA;AANJ;;AAUA;EACE,0CAAA;EACA,qBAAA;AAPF;;AAUA;EACE,WAAA;EACA,eAAA;AAPF;ACjKE;EDsKF;IAKI,eAAA;EANF;AACF;;AASA;EACE,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,SAAA;EACA,yBAAA;EACA,+CAAA;EACA,sBAAA;AANF;;AASA;EACE,gBAAA;EACA,0BAAA;EACA,aAAA;EAGA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AARF;AAUE;EACE,WAAA;EACA,YAAA;AARJ;AAWE;EACE,YAAA;AATJ","sourcesContent":["@import \"mixins\";\n.courseList {\n  border-top: 1px solid var(--color-gray-strokes);\n  border-radius: 0;\n  margin: 1px 0;\n  padding: 16px 16px 0px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 0;\n}\n\n.courseItem {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 1px 0;\n}\n\n.courseDiamond {\n  flex-shrink: 0;\n}\n\n.courseText {\n  font-size: 14px;\n  line-height: 1.5;\n  color: #1a1a1a;\n}\n\n.calendarSection {\n  overflow-x: hidden;\n  max-width: 100%;\n\n  @include md {\n    overflow-x: visible;\n    max-width: none;\n  }\n}\n\n.calendarGrid {\n  display: none;\n\n  @include md {\n    display: flex;\n    gap: 16px;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n.calendarCarousel {\n  display: block;\n\n  @include md {\n    display: none;\n  }\n}\n\n.carouselContainer {\n  overflow-x: hidden;\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n  margin: 10px 0;\n}\n\n.carouselTrack {\n  display: flex;\n  transition: transform 0.3s ease-in-out;\n  gap: 8px;\n  padding: 0 calc(50% - 82px);\n}\n\n.carouselSlide {\n  flex: 0 0 163px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.calendarCard {\n  width: 160px;\n  height: 60px;\n  border: 3px solid var(--color-gray-strokes);\n  border-radius: 12px;\n  background-color: var(--color-white);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  flex-shrink: 0;\n  position: relative;\n  overflow: hidden;\n\n  &:hover {\n    border: 1px solid var(--color-gray-strokes);\n    background: var(--color-bg-light-blue);\n  }\n\n  &:focus {\n    border-color: black;\n  }\n}\n\n.calendarCardSelected {\n  border-color: black;\n  background-color: var(--color-bg-light-blue);\n\n  &:hover {\n    background-color: var(--color-bg-light-blue);\n    border-color: black;\n  }\n}\n\n.calendarIcon {\n  width: 32px;\n  height: 32px;\n  object-fit: contain;\n  position: relative;\n  transition: all 0.3s ease;\n\n  @include md {\n    width: 40px;\n    height: 40px;\n  }\n\n  .calendarCard:hover & {\n    filter: \n      drop-shadow(-16px 0 0 rgba(0, 0, 0, 0.4))\n      drop-shadow(-32px 0 0 rgba(0, 0, 0, 0.2))\n      drop-shadow(16px 0 0 rgba(0, 0, 0, 0.4))\n      drop-shadow(32px 0 0 rgba(0, 0, 0, 0.2));\n  }\n\n}\n\n.dotsContainer {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 16px;\n  margin-bottom: 8px;\n}\n\n.dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: var(--color-gray-strokes);\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  padding: 0;\n\n  &:hover {\n    background-color: var(--color-accent-blue);\n    opacity: 0.7;\n  }\n\n  &:focus {\n    outline: 2px solid var(--color-accent-blue);\n    outline-offset: 2px;\n  }\n}\n\n.dotActive {\n  background-color: var(--color-accent-blue);\n  transform: scale(1.2);\n}\n\n.addEventsButton {\n  width: 100%;\n  margin-top: 0px;\n\n  @include md {\n    margin-top: 0px;\n  }\n}\n\n.optionalSyncText {\n  width: 100%;\n  text-align: center;\n  color: var(--color-text-secondary, #666);\n  font-size: 16px;\n  margin: 0;\n  padding: 16px 16px 0 16px;\n  border-top: 1px solid var(--color-gray-strokes);\n  box-sizing: border-box;\n}\n\n.infoMessage {\n  border-radius: 0;\n  padding: 0px 16px 0px 16px;\n  display: flex;\n  //align-items: center;\n  //text-align: center;\n  justify-content: center;\n  gap: 4px;\n  color: #4285F4;\n  font-size: 16px;\n  \n  .infoIcon {\n    width: 22px;\n    height: 22px;\n  }\n  \n  span {\n    opacity: 0.8;\n  }\n}","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"courseList": `styles_courseList__nzmew`,
	"courseItem": `styles_courseItem__QkFyK`,
	"courseDiamond": `styles_courseDiamond__j6Q3K`,
	"courseText": `styles_courseText__XFMuP`,
	"calendarSection": `styles_calendarSection__Tt7PN`,
	"calendarGrid": `styles_calendarGrid__G83Hd`,
	"calendarCarousel": `styles_calendarCarousel__71hxB`,
	"carouselContainer": `styles_carouselContainer__--4RE`,
	"carouselTrack": `styles_carouselTrack__7z2nE`,
	"carouselSlide": `styles_carouselSlide__Thm9y`,
	"calendarCard": `styles_calendarCard__F-ZAL`,
	"calendarCardSelected": `styles_calendarCardSelected__4OWW8`,
	"calendarIcon": `styles_calendarIcon__A2iDz`,
	"dotsContainer": `styles_dotsContainer__+fGv7`,
	"dot": `styles_dot__84eo8`,
	"dotActive": `styles_dotActive__Ae2Bc`,
	"addEventsButton": `styles_addEventsButton__SCGyT`,
	"optionalSyncText": `styles_optionalSyncText__O-fg7`,
	"infoMessage": `styles_infoMessage__yNRX8`,
	"infoIcon": `styles_infoIcon__G3ezc`
};
export default ___CSS_LOADER_EXPORT___;
